// extracted by mini-css-extract-plugin
export default {"animation-fast-ms":"300","animation-slow-ms":"800","FeedbackButton":"index_FeedbackButton__3YPgX typography_heading__HQNiU"};